import { z } from "zod/v4";
import { paginatedSessionsSchema } from "../../schemas/training";
import { fetchApi, fetchVoid } from "../internal";

export const sessions = {
	cancel: (clubId: string, seasonId: string, eventId: string) =>
		fetchVoid(`/clubs/${clubId}/training/seasons/${seasonId}/sessions/${eventId}`, {
			method: "PATCH",
		}),
	deleteAll: (clubId: string, seasonId: string, groupId?: string, afterDate?: string) => {
		const searchParams = new URLSearchParams();
		if (groupId) searchParams.set("group_id", groupId);
		if (afterDate) searchParams.set("after_date", afterDate);
		const qs = searchParams.toString();
		return fetchApi(
			`/clubs/${clubId}/training/seasons/${seasonId}/sessions${qs ? `?${qs}` : ""}`,
			z.object({ deleted: z.number() }),
			{ method: "DELETE" },
		);
	},
	list: (clubId: string, seasonId: string, params?: { group_id?: string; after_date?: string }) => {
		const searchParams = new URLSearchParams();
		if (params?.group_id) searchParams.set("group_id", params.group_id);
		if (params?.after_date) searchParams.set("after_date", params.after_date);
		const qs = searchParams.toString();
		return fetchApi(
			`/clubs/${clubId}/training/seasons/${seasonId}/sessions${qs ? `?${qs}` : ""}`,
			paginatedSessionsSchema,
		);
	},
};
